<div class="popcontainer">
    
    
    <div class="coverareawrap">
        <div class="titlewrap">
            <h2>
                {{data?.item?.title}}
            </h2>
            <h4>
                $ {{data?.item?.standardPrice}}
            </h4>
        </div>
    
    <div  class="scrollcontent scroller">
        <div class="productdescprt">
            <div class="imgbox">
                <img [src]="data?.item?.image" alt="product-image" width="160" height="160">
            </div>
            <p>
                 {{data?.item?.description}}
            </p>
        </div>

        <div class="planslider">
                <div class="crousel_arrow">
                    <div [ngClass]="
                            'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')
                        "
                        (click)="slider.prev()"></div>
                        <div *ngIf="slider" [ngClass]="
                            'arrow arrow--right ' +
                            (slider.track.details.slides.length - 1 === currentSlide
                            ? 'arrow--disabled'
                            : '')
                        "
                        (click)="slider.next()"
                        ></div>
                </div>
                <div class="keen-slider" #sliderRef>
                    <div class="keen-slider__slide number-slide{{0}}" *ngIf="data?.item?.whatWeCover">
                        <div class="coveragestage">
                            <h3>What is covered?</h3>
                            <p>
                               {{data?.item?.whatWeCover}}
                            </p>
                        </div>
                    </div>
                    <div class="keen-slider__slide number-slide{{1}}" *ngIf="data?.item?.notCovered">
                        <div class="coveragestage">
                            <h3>What is not covered?</h3>
                            <p>
                                {{data?.item?.notCovered}}
                            </p>
                        </div>
                    </div>
                    <div class="keen-slider__slide number-slide{{2}}" *ngIf="data?.item?.additionalInformation">
                        <div class="coveragestage">
                            <h3>Additional information</h3>
                            <p>
                                {{data?.item?.additionalInformation}}
                            </p>
                        </div>
                    </div>
                </div>
               
            </div>
     
    </div>

        
    </div>
    
    <div class="coverage">
        <div *ngIf="data?.item?.maximumCoverage">
            <h2>MAXIMUM COVERAGE</h2>
            <span>{{data?.item?.maximumCoverage ? (data?.item?.maximumCoverage) : ''}}</span>
        </div>
        <button (click)="closePop()">Close</button>
    </div>
</div>

